import type { TFunction } from "i18next";
import { dayMs, hourMs, minuteMs } from "verdi-common/timeConstants";
import { formatClockTime, formatDayTime, isSameLocalDay } from "../../format";
import type { ReadoutMode } from "./readout";

/** "59m ago", "1h ago", "2d ago", in the locale's words. */
export function formatAgo(ms: number, t: TFunction): string {
    const ago = (count: number, unitKey: string) => t("time.time-ago", { timeAgo: `${count}${t(unitKey)}` });
    if (ms < hourMs) return ago(Math.floor(ms / minuteMs), "time.minute.char");
    if (ms < dayMs) return ago(Math.floor(ms / hourMs), "time.hour.char");
    return ago(Math.floor(ms / dayMs), "time.day.char");
}

export function formatReadoutTime(mode: ReadoutMode, timeMs: number, nowMs: number): string {
    const isRecent = (mode === "live" || mode === "stale") && isSameLocalDay(timeMs, nowMs);
    return isRecent ? formatClockTime(timeMs) : formatDayTime(timeMs);
}
